export default __webpack_public_path__ + "static/media/10.01ef49aa.webp";